import React from "react";
import SingleImageBox from "components/common/singleImageBox";
import InfoBox from "components/common/infoBox";
import InfoBoxMain from "components/common/infoBoxMain";
import Grid from "@mui/material/Grid";
import geccoMain from "assets/images/gecco-main.png";
import geccoLogo from "assets/images/gecco-logo.png";
import DoubleImageBox from "components/common/doubleImageBox";
import geccoA from "assets/images/gecco-a.png";
import geccoB from "assets/images/gecco-b.png";
import geccoC from "assets/images/gecco-c.png";

import "components/common/landingLayout/index.scss";
import { useTranslation } from "react-i18next";
const Gecco = () => {
  const { t } = useTranslation();
  return (
    <Grid container>
      <Grid
        item
        md={6}
        xs={12}
        marginTop={10}
        marginBottom={10}
        className="left-align padding-left-col">
        <InfoBoxMain
          imgSrc={geccoLogo}
          heading={t("gecco-card-1.heading")}
          infoText={t("gecco-card-1.infoText")}
          linkText={t("gecco-card-1.linkText")}
        />
      </Grid>
      <Grid
        item
        md={6}
        xs={12}
        marginTop={10}
        marginBottom={10}
        className="center-align padding-right-col">
        <SingleImageBox imgSrc={geccoMain} width="40rem"></SingleImageBox>
      </Grid>
      <Grid item md={6} xs={12} className="bg-light1 center-align padding-left-col">
        <DoubleImageBox imgSrc={geccoA} />
      </Grid>
      <Grid item md={6} xs={12} className="bg-light1 left-align padding-righ-col">
        <InfoBox
          headingText={t("gecco-card-2.headingText")}
          infoText={t("gecco-card-2.infoText")}
        />
      </Grid>
      <Grid item md={6} xs={12} className=" left-align padding-left-col">
        <InfoBox
          headingText={t("gecco-card-3.headingText")}
          infoText={t("gecco-card-3.infoText")}
        />
      </Grid>
      <Grid item md={6} xs={12} className=" center-align padding-righ-col">
        <DoubleImageBox imgSrc={geccoB} />
      </Grid>
      <Grid item md={6} xs={12} marginTop={10} className="bg-light1 center-align padding-left-col">
        <DoubleImageBox imgSrc={geccoC} />
      </Grid>
      <Grid item md={6} xs={12} marginTop={10} className="bg-light1 left-align padding-righ-col">
        <InfoBox
          headingText={t("gecco-card-4.headingText")}
          infoText={t("gecco-card-4.infoText")}        />
      </Grid>
      <Grid item xs={12} sx={{ height: "210px" }}></Grid>
    </Grid>
  );
};

export default Gecco;
